import React from 'react';

const DeleteRecurringModal = ({ open, onClose, onDeleteThis, onDeleteFollowing, lesson, saving = false }) => {
  const [option, setOption] = React.useState('this');
  React.useEffect(() => { if (open) setOption('this'); }, [open]);
  if (!open || !lesson) return null;
  const okDisabled = saving;
  return (
    <div className="modal-overlay" style={{ zIndex: 3000 }}>
      <div className="modal-content" style={{ minWidth: 270, background: '#f7f7f8', borderRadius: 12, boxShadow: '0 2px 16px #0002', padding: 20, textAlign: 'center' }}>
        <h3 style={{ fontSize: 17, fontWeight: 600, color: '#181818', marginBottom: 18, marginTop: 0, letterSpacing: 0.1 }}>Delete recurring event</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'flex-start', margin: '0 auto 18px auto', maxWidth: 220 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 15, fontWeight: 500, color: okDisabled ? '#999' : '#222', cursor: okDisabled ? 'default' : 'pointer' }}>
            <input type="radio" checked={option === 'this'} onChange={() => !okDisabled && setOption('this')} disabled={okDisabled} style={{ accentColor: '#111', width: 18, height: 18, margin: 0 }} />
            This event
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 15, fontWeight: 500, color: okDisabled ? '#999' : '#222', cursor: okDisabled ? 'default' : 'pointer' }}>
            <input type="radio" checked={option === 'following'} onChange={() => !okDisabled && setOption('following')} disabled={okDisabled} style={{ accentColor: '#111', width: 18, height: 18, margin: 0 }} />
            This and following events
          </label>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 14, marginTop: 8 }}>
          <button type="button" onClick={onClose} disabled={okDisabled} style={{ background: 'none', border: 'none', color: okDisabled ? '#aaa' : '#444', fontSize: 15, fontWeight: 500, cursor: okDisabled ? 'not-allowed' : 'pointer', padding: '7px 16px', borderRadius: 18 }}>Cancel</button>
          <button
            type="button"
            onClick={() => {
              if (okDisabled) return;
              if (option === 'this') onDeleteThis();
              else onDeleteFollowing();
            }}
            disabled={okDisabled}
            className={saving ? 'schedule-add-btn-loading' : ''}
            style={{
              background: '#111',
              color: '#fff',
              fontWeight: 600,
              fontSize: 15,
              border: 'none',
              borderRadius: 18,
              padding: '7px 28px',
              minWidth: 100,
              boxShadow: 'none',
              cursor: okDisabled ? 'not-allowed' : 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
            }}
            aria-busy={saving}
          >
            {saving ? <span className="schedule-add-btn-spinner" aria-hidden /> : 'OK'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteRecurringModal;
